import request from '@/utils/request';
import * as types from './types';
const v2Prefix = '/api/v2';
export function getLLmSections(params: types.LlmSectionsParams): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/llm_sections`,
    method: 'get',
    params
  });
}
export function getLLmSectionsById(llmSectionsId: string): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/llm_sections/${llmSectionsId}`,
    method: 'get'
  });
}
export function getLLmLabelsTree(params: types.LlmLabelsTree): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/llm-labels/tree`,
    method: 'get',
    params
  });
}
export function getLLmLLmDicTree(params: types.LlmLabelsTree): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/llm-dict/tree`,
    method: 'get',
    params
  });
}

export function getModelGroup(params: types.ModelGroups): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/model_groups`,
    method: 'get',
    params
  });
}
export function getProjectFilter(params: types.ProjectFilter): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/nauth/projects/filter`,
    method: 'get',
    params
  });
}

// 给项目添加 star
export function addProjectStar(data: any): Promise<any> {
  return request({
    url: `${v2Prefix}/projects/${data.project_id}/star`,
    method: 'post',
    data
  });
}
// 取消项目 star
export function cancelProjectStar(data: any): Promise<any> {
  return request({
    url: `${v2Prefix}/projects/${data.project_id}/unstar`,
    method: 'post',
    data
  });
}
export function getProjectByGroupId(params: types.ProjectFilter): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/nauth/groups/${params.groupId}/projects`,
    method: 'get',
    params
  });
}
export function getProjectByGroupAll(): Promise<any> {
  // 底座不支持，参数暂时写死
  return request({
    url: `${v2Prefix}/channel/projects?channel_id=6683b82075f1b657f59f842e&page=1&per_page=200&repo_type=1`,
    method: 'get'
  });
}

// 获取热门space列表
export function getHotSpaceList(params: { page: string | number, per_page: string | number; }): Promise<any> {
  return request({
    url: `/aihub/api/v1/homepage/space`,
    method: 'get',
    params
  });
}

// 获取热门项目列表
export function getHotProjectList(params: { page: string, per_page: string, repo_type: 'model' | 'dataset'; }): Promise<any> {
  return request({
    url: `/aihub/api/v1/homepage/project`,
    method: 'get',
    params
  });
}

// 获取组织的Space项目列表
export function getOrgSpaceList(params: any): Promise<any> {
  return request({
    url: `/aihub/api/v1/space/${params.namespace}/get_page_of_namespace`,
    method: 'get',
    params: {
      page: params.page,
      per_page: params.per_page,
      search: params.search,
      order_by: params.order_by,
      sort: params.sort,
      repo_type: 'space'
    }
  });
}

// 获取Space首页列表
export function getSpaceHomeList(params: any): Promise<any> {
  return request({
    url: `/aihub/api/v1/space/get_page`,
    method: 'get',
    params: {
      page: params.page,
      per_page: params.per_page,
      search: params.search,
      order_by: params.order_by,
      sort: params.sort,
      repo_type: 'space',
      label_id: params.labelId
    }
  });
}

// 获取Space行业标签L
export function getSpaceLabelsList() {
  return request({
    url: `/aihub/api/v1/space/setting/labels`,
    method: 'get',
    params: {
      hot: 1
    }
  });
}
// 数据集查看器 - split
export function getSplitData(params: { dataset: string | number; }): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/datasets/splits`,
    method: 'get',
    params
  });
};

// 数据集查看器 - rows
export function getRowsData(params: {
  config?: string,
  dataset: string | number,
  split: string,
  page: number;
  perPage: number;
}): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/datasets/rows`,
    method: 'get',
    params
  });
};

// 数据集查看器 - statistics
export function getStatisticsData(params: {
  config?: string,
  dataset: string | number,
  split: string;
}): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/datasets/statistics`,
    method: 'get',
    params
  });
};

// 检查是否放开 AiHub 项目权限
export function checkAiHubPermission(): Promise<any> {
  return request({
    url: `${v2Prefix}/ai-hub/ai/project/user/check`,
    method: 'get'
  });
};

// 检查是否有 Space 权限
export function checkAccessAuth(params: { type?: string, }): Promise<any> {
  return request({
    url: `/aihub/api/v1/invitation/code/check_access_auth`,
    method: 'get',
    params
  });
}

// 激活邀请码
export function verifyInvitationCode(code: string): Promise<any> {
  return request({
    url: `/aihub/api/v1/invitation/code/verify/${code}`,
    method: 'put'
  });
}
// 激活 - ai用户
export function activeAiUser(data: { form_role: any, form_objective: any, form_experience: any }): Promise<any> {
  return request({
    url: `/aihub/api/v1/ai/user/active`,
    method: 'post',
    data
  });
}

// 创建 - ai用户
export function createAiUser(): Promise<any> {
  return request({
    url: `/aihub/api/v1/ai/user/create`,
    method: 'post'
  });
}

// 创建 - ai用户
export function getAiUserStatus(): Promise<any> {
  return request({
    url: `/aihub/api/v1/ai/user/get_active_status`,
    method: 'get'
  });
}

// 获取预发布状态
export function getProjectPublishList(data: {project_ids: number[]}): Promise<any> {
  return request({
    url: `/aihub/api/v1/projects/publish/list`,
    method: 'post',
    data
  });
}

// 获取主题菜单
export function getThemeConfigList(): Promise<any> {
  return request({
    url: `/aihub/api/v1/theme/label/config/list`,
    method: 'get'
  });
}

// 获取项目发布时间
export function getProjectPublishTime(params: { project_ids: number[]; }): Promise<any> {
  const projectIds = params.project_ids.map((item, index) => {
    if (index === 0) {
      return `?project_ids=${item}`;
    }
    return `&project_ids=${item}`;
  });
  return request({
    url: `/aihub/api/v1/projects/publish/first/publish-time${projectIds.join('')}`,
    method: 'get'
  });
}

// model card涉及的模型数据集的搜索接口
export function getRepoMetadataData(params: any): Promise<any> {
  return request({
    url: `/api/v1/search/nauth/query`,
    method: 'get',
    params
  });
}

// 获取元数据字典
export function getMetadataDict(params?: { type?: string }): Promise<any> {
  return request({
    url: `/aihub/api/v1/metadata/dict`,
    method: 'get',
    params
  });
}

// 获取模型元数据字典
export function validateMetadataDict(data: any): Promise<any> {
  return request({
    url: `/aihub/api/v1/metadata/dict/validate`,
    method: 'post',
    data
  });
}

// 合集点赞
export function upvoteCollection(data: any) {
  return request({
    url: `/aihub/api/v1/collection/star`,
    method: 'post',
    data
  });
}

// 创建合集
export function createCollection(data: any): Promise<any> {
  return request({
    url: `/aihub/api/v1/collection`,
    method: 'post',
    data
  });
}

// 添加内容到合集
export function addToCollection(data: any): Promise<any> {
  return request({
    url: `/aihub/api/v1/collection/content`,
    method: 'post',
    data
  });
}

// 在项目中获取合集列表
export function getCollectionList(): Promise<any> {
  return request({
    url: `/aihub/api/v1/collection/query_in_project`,
    method: 'get'
  });
}

// 获取AI社区弹窗配置
export function getAiCommunityPopupConfig() {
  return request({
    url: `/api/v1/search/common/configs/ai_community_popup`,
    method: 'get'
  });
}
